import React from 'react'
import useWebsiteId from '@hooks/useWebsiteId'
import useQuery from '@packages/apollo-hooks/lib/useApolloQuery'
import Page from '@page-components/Page'
import gql from 'graphql-tag'

import styles from './styles.module.css'

export default function EMenuDynamicPage(props) {
  const {emenuId} = props
  const websiteId = useWebsiteId()
  const {page} = useQuery({
    query: gql`
      query getWebsitePage_cached($websiteId: ID, $path: String) {
        page: websitePage(websiteId: $websiteId, path: $path) {
          _id
        }
      }
    `,
    variables: {
      websiteId,
      path: '/emenu/' + emenuId
    },
    partial: true
  })

  if (!page) return null
  return (
    <div className={styles.container}>
      <Page pageId={page._id} />
    </div>
  )
}
